import { render, staticRenderFns } from "./df-card-product-feautured.vue?vue&type=template&id=6b47e716&"
import script from "./df-card-product-feautured.ts?vue&type=script&lang=js&"
export * from "./df-card-product-feautured.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports